import $ from 'jquery';
import { protectRoute, commonMiddleware } from '../middleware';
import { router } from '~src/router';
import { openCanvasById } from '~loader';
import { updateNavbarItemVisibility } from '~core/navbar/utils';
import { showSpinner, getMetadata, hideSpinner } from '~loader/loader-utils';
import { modifyState } from '~src/state';
import { EDITOR_MODE_DEFAULT } from '~config/editorConstants';

export const canvasRoute = async ({ data }) => {
  await protectRoute();
  await commonMiddleware();

  $('#route-canvas').show();
  showSpinner();

  if (!data || !data.id) {
    return router.navigate(process.env.ROUTE_START);
  }

  $('#navbar-private').hide();
  $('#navbar-canvas').show();
  // Ensure Print button is explicitly visible once navbar is shown
  try {
    $('#editor-menu-print').show().removeClass('d-none');
  } catch (e) {
    // non-blocking
  }
  // Ensure nav items reflect latest visibility once navbar is visible
  try {
    updateNavbarItemVisibility(['#giotto-video-preview', '#editor-menu-print']);
  } catch (e) {
    // non-blocking
  }

  modifyState('editorMode', EDITOR_MODE_DEFAULT);
  await openCanvasById(data.id);

  const metadata = getMetadata();
  document.title =
    [
      metadata.projectTypeName,
      metadata.templatesCategoryName,
      metadata.formatName,
      metadata.servizioName,
    ].join(' ') + ' | Giotto';

  hideSpinner();
};
